import React from 'react';
import { Sparkles, Plus, X } from 'lucide-react';
import EditableText from '../../components/EditableText';

function AnnouncementMarquee({ data, editing, onChange }) {
  const items = data.items || [];

  const updateItem = (idx, val) => {
    const next = items.slice();
    next[idx] = val;
    onChange && onChange({ ...data, items: next });
  };

  const addItem = () => {
    onChange && onChange({ ...data, items: [...items, 'New announcement'] });
  };

  const removeItem = (idx) => {
    const next = items.filter((_, i) => i !== idx);
    onChange && onChange({ ...data, items: next });
  };

  if (editing) {
    return (
      <div className="relative bg-olive-footer text-white border-y border-accent/20 py-4">
        <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 px-6 mb-2">
          Marquee items — edit inline
        </div>
        <div className="flex flex-wrap items-center gap-3 px-6">
          {items.map((t, i) => (
            <div
              key={i}
              className="inline-flex items-center gap-2 bg-white/5 border border-white/15 rounded-full pl-3 pr-2 py-1 group"
            >
              <Sparkles size={12} className="text-accent shrink-0" />
              <EditableText
                value={t}
                onChange={(v) => updateItem(i, v)}
                as="span"
                className="text-xs uppercase tracking-[0.2em] text-white/90 min-w-[80px] outline-none"
              />
              <button
                type="button"
                onClick={() => removeItem(i)}
                className="opacity-0 group-hover:opacity-100 transition text-white/60 hover:text-red-300"
                title="Remove item"
              >
                <X size={12} />
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={addItem}
            className="inline-flex items-center gap-1 text-xs text-white/70 hover:text-white border border-dashed border-white/30 rounded-full px-3 py-1"
          >
            <Plus size={12} />
            Add item
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative bg-olive-footer text-white overflow-hidden border-y border-accent/20">
      <div className="absolute inset-0 bg-grid-olive [background-size:28px_28px] opacity-25" />
      <div className="relative flex animate-[marquee_30s_linear_infinite] whitespace-nowrap py-3">
        {Array.from({ length: 2 }).flatMap((_, dup) =>
          items.map((t, i) => (
            <span key={`${dup}-${i}`} className="mx-8 inline-flex items-center gap-3 text-xs uppercase tracking-[0.32em] text-white/80">
              <Sparkles size={12} className="text-accent" />
              {t}
              <span className="text-accent/60">·</span>
            </span>
          ))
        )}
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </div>
  );
}

export default AnnouncementMarquee;
